import { msgTypes } from "../../constants/msgTypes";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
import { UtilService } from "../../services/shared/UtilService";
import { useNavigate } from "react-router-dom";
import UserListFilter from "./UserListFilter";
import { MuiInput } from "../basicComponent/MuiInput";
import React, { useState } from "react";
import Pagination from "@mui/material/Pagination";
import ActivityIndicator from "../basicComponent/ActivityIndicator";
import { Switch } from "@mui/material";

type CorporateListProps = {
  businessId: string;
  businessName: string;
  mobileNumber: string;
  emailId: string;
  updated_at: string;
  balance: string;
  corporateType: string;
  status?: any;
  phoneNo: string;
  no: number;
  handleEditClick: () => void;
  getCorporateList: () => void;
};

type User = {
  username: string;
  roleName: string;
  branch: string;
  id: string;
  mobileNumber: string;
  defaultCustomer: string;
  status: string;
  createdAt: string;
  corporate: string;
  user: {
    firstName: string;
    lastName: string;
    email: string;
  };
  employeeCode?: string;
};

const CMCard = ({
  balance,
  businessId,
  businessName,
  corporateType,
  emailId,
  mobileNumber,
  phoneNo,
  status,
  updated_at,
  no,
  handleEditClick,
  getCorporateList,
}: CorporateListProps) => {
  const { showSuccess, showError, showInfo, showConfirm } = useSweetAlert();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
    getUserList(); // or businessId if backend filters by that
  };
  const handleClose = () => setOpen(false);
  const [userList, setUserList] = useState<User[]>([]);
  const [currentPage, setCurrentPage] = useState(1); // State for current page
  const [itemsPerPage] = useState(5); // Number of items per page
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const sendWelcomeEmail = async () => {
    const payload = {
      email: emailId,
    };
    try {
      const response = await UtilService.sendWelcomeEmail(payload);
      if (response?.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess("Email sent successfully");
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleToggleBtn = () => {
    if (status) {
      showConfirm(
        "",
        `Are you sure you want to deactivate ${businessName} ? `
      ).then((result) => {
        if (result?.isConfirmed) {
          const payload = {
            isActive: false,
          };
          editCorporateStatus(payload, businessId ?? "");
        }
      });
    } else {
      showConfirm(
        "",
        `Are you sure you want to Activate ${businessName} ? `
      ).then((result) => {
        if (result?.isConfirmed) {
          const payload = {
            isActive: true,
          };
          editCorporateStatus(payload, businessId ?? "");
        }
      });
    }
  };

  const editCorporateStatus = async (payload: {}, id: string) => {
    try {
      const response = await UtilService.editCorporate(payload, id);
      if (!!response?.data) {
        showSuccess("Success!", "Corporate has been updated successfully.");
        navigate("/corporatelist");
        getCorporateList();
      }
    } catch (error) {
      console.log("error while edit corporate", error);
    }
  };

  const handleClick = (id: string) => {
    const userData = userList?.filter((i) => i?.id === id);
    navigate("/usermanagement", {
      state: {
        data: userData,
      },
    });
  };
  const getUserList = async () => {
    setLoading(true);
    const param = {
      corporate: businessName,
    };
    const response = await UtilService.getUserList(param);

    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      setUserList(response?.data);
    }
    setLoading(false);
  };

  const CMFilterPopUp = () => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userList?.slice(indexOfFirstItem, indexOfLastItem);

    return (
      <>
        <div className="row ">
          {loading ? (
            <tr>
              <td colSpan={12} style={{ width: "613px" }}>
                <div className="d-flex justify-content-center align-items-center py-4">
                  <ActivityIndicator />
                </div>
              </td>
            </tr>
          ) : (
            <>
              <table className="table table-bordered table-hover">
                <thead className="table-light text-center">
                  <tr>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Employee Code</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Welcome Mail</th>
                    <th>Status</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.length > 0 ? (
                    currentItems.map((user, index) => (
                      <tr key={index}>
                        <td>
                          <div className="sort">
                            {user.user.firstName + " " + user.user.lastName}
                          </div>
                        </td>
                        <td>
                          <div className="sort">{user.user.email}</div>
                        </td>
                        <td>
                          <div className="sort">{user.mobileNumber}</div>
                        </td>
                        <td>
                          <div className="sort">{user.employeeCode}</div>
                        </td>
                        <td>
                          <div className="sort">
                            {new Date(user.createdAt).toLocaleDateString()}
                          </div>
                        </td>
                        <td>
                          <div className="sort">{user.corporate}</div>
                        </td>
                        <td>
                          <span
                            className="badge badge-sm badge-outline cursor-pointer"
                            onClick={sendWelcomeEmail}
                          >
                            <i className="fa-solid fa-share me-1"></i>Send
                          </span>
                        </td>
                        <td className="text-capitalize">
                          <div
                            className={
                              user.status === "active"
                                ? "text-success"
                                : "text-danger"
                            }
                          >
                            {user.status}
                          </div>
                        </td>
                        <td>
                          <span
                            className="badge badge-sm badge-warning badge-outline cursor-pointer"
                            onClick={() => handleClick(user.id)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9}>
                        {/* Adjust the number to match your column count */}
                        <div className="d-flex flex-column align-items-center justify-content-center py-4">
                          <div
                            className="d-flex align-items-center justify-content-center bg-light rounded-circle mb-3"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <img
                              src="media/images/remove-folder.png"
                              alt="remove-folder"
                              style={{ maxWidth: "40px", maxHeight: "40px" }}
                            />
                          </div>
                          <h5 className="text-muted mb-0 fw-bold fs-5">
                            No User Found
                          </h5>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              <div className="card-footer justify-end md:justify-end flex-col md:flex-row gap-5 text-gray-600 text-2sm font-medium">
                <div className="flex items-end gap-4 order-1 md:order-2">
                  <Pagination
                    count={Math.ceil(userList?.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <tr>
        <td className="text-center">
          <div className="sort">{no}</div>
        </td>
        <td>
          <div
            title=" User List"
            className="sort text-primary cursor-pointer"
            onClick={handleOpen}
          >
            {businessName}
          </div>
        </td>
        <td>
          <div className="sort">{phoneNo}</div>
        </td>
        <td>
          <div className="flex -space-x-2">
            <div className="flex">
              <div className="sort">{mobileNumber}</div>
            </div>
          </div>
        </td>
        <td>
          <div className="sort">{emailId}</div>
        </td>
        <td>
          <div className="sort">{updated_at}</div>
        </td>
        <td>
          <div className="sort">{balance}</div>
        </td>
        <td>
          <div className="sort">{corporateType}</div>
        </td>
        <td>
          {/* <span className="badge badge-sm badge-primary badge-outline">
              <i className="fa-solid fa-check me-1 mt-1"></i>
              {status}
            </span> */}
          {/* <span
            className={` text-sm font-medium text-decoration-underline ${
              status ? "text-success" : "text-danger"
            }`}
          >
            {status ? "Active" : "Inactive"}
          </span> */}
          <Switch
            checked={status}
            onClick={() => handleToggleBtn()}
            size="small" // optional: keeps it compact
          />
        </td>
        <td>
          <span
            className="badge badge-sm  badge-outline cursor-pointer"
            onClick={sendWelcomeEmail}
          >
            <i className="fa-solid fa-share me-1 mt-1"></i>
            Send
          </span>
        </td>
        <td onClick={handleEditClick}>
          <span className="badge badge-sm badge-warning badge-outline cursor-pointer">
            <i className="fa-solid fa-pen-to-square pe-0"></i>
          </span>
        </td>
      </tr>

      {/*-----------------pop code----------------------------  */}
      <UserListFilter
        header={`User List - ${businessName}`}
        children={<CMFilterPopUp />}
        isVisible={open}
        handleClose={() => handleClose()}
      />
    </>
  );
};

export default CMCard;
